import { render, staticRenderFns } from "./ResourceAccount.vue?vue&type=template&id=3a5d0ff0&"
import script from "./ResourceAccount.vue?vue&type=script&lang=js&"
export * from "./ResourceAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports